import React from "react";

const SendIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5001 8.49998L9.50011 11.5M18.7881 1.53098C18.883 1.49823 18.9852 1.49284 19.083 1.51542C19.1808 1.53801 19.2703 1.58765 19.3412 1.65869C19.4121 1.72972 19.4617 1.81927 19.4841 1.91711C19.5065 2.01495 19.501 2.11713 19.4681 2.21198L13.5441 19.142C13.5087 19.2432 13.4436 19.3314 13.3574 19.3952C13.2712 19.459 13.1678 19.4954 13.0607 19.4997C12.9536 19.504 12.8476 19.476 12.7565 19.4194C12.6655 19.3627 12.5936 19.28 12.5501 19.182L9.33111 11.94C9.27695 11.8195 9.18054 11.7231 9.06011 11.669L1.81811 8.44898C1.7204 8.40535 1.63802 8.33343 1.58161 8.24251C1.5252 8.15159 1.49735 8.04584 1.50165 7.93892C1.50596 7.83201 1.54223 7.72884 1.60577 7.64275C1.66931 7.55666 1.75721 7.4916 1.85811 7.45598L18.7881 1.53098Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendIcon;
